import { render, staticRenderFns } from "./RatingSetter.vue?vue&type=template&id=d2fe56cc&scoped=true&"
import script from "./RatingSetter.vue?vue&type=script&lang=js&"
export * from "./RatingSetter.vue?vue&type=script&lang=js&"
import style0 from "./RatingSetter.vue?vue&type=style&index=0&id=d2fe56cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fe56cc",
  null
  
)

export default component.exports